import { TaskTemplateServiceTemplateQuery } from "../../../graphql-types";
import { pp } from "../../shared/utilities/pretty-print";

interface selectTaskTemplateServiceReadyToHireProps {
  callToActionUrl: string;
  displayCta: string;
}

export function selectTaskTemplateServiceReadyToHire(
  data: TaskTemplateServiceTemplateQuery
): selectTaskTemplateServiceReadyToHireProps {
  if (data.taskTemplateServicePage?.displayCta == null) {
    throw Error(
      `data.taskTemplateServicePage?.displayCta is null: ${pp({ data })}`
    );
  }

  if (data.taskTemplateServicePage?.callToActionUrl == null) {
    throw Error(
      `data.taskTemplateServicePage?.callToActionUrl is null: ${pp({ data })}`
    );
  }
  return {
    callToActionUrl: data.taskTemplateServicePage?.callToActionUrl,
    displayCta: data.taskTemplateServicePage?.displayCta,
  };
}
